import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import getDropdownOptionsData, { optionsKeys } from './getDropdownOptionsData';

const getFinancingDisclaimerParams = (finance, pricing, financeContext, language, dropdownOptions) => {
  const [yearData, modelData] = getDropdownOptionsData(dropdownOptions, [optionsKeys.year, optionsKeys.model]);
  const modelName = modelData?.text;
  const modelYear = yearData?.value;
  const paymentFrequency = financeContext?.options;

  let numberOfPayments;
  switch (paymentFrequency) {
    case 'weekly':
      numberOfPayments = finance.weekly.noOfWeeklyPayments;
      break;
    case 'monthly':
      numberOfPayments = finance.monthly.termOptionsDefault;
      break;
    case 'biweekly':
      numberOfPayments = finance.biweekly.noOfBiweeklyPayments;
      break;
    default:
      numberOfPayments = null;
  }

  const formatPriceValue = value => formatPrice(value || 0, language, 2);
  const freightPdi = finance?.monthly?.freightPdi;
  const ppsaRegistrationFee = finance?.monthly?.levies?.ppsaRegistrationFee?.value;
  const registeringAgentFee = finance?.monthly?.levies?.registeringAgentFee?.value;
  const costOfBorrowing = finance?.monthly?.totalCostOfBorrowing;
  const totalAmount = pricing?.total;

  return {
    dateFrom: finance?.monthly?.ratePeriodStart,
    dateTo: finance?.monthly?.ratePeriodEnd,
    modelYear,
    modelName,
    sellingPrice: formatPriceValue(pricing?.total),
    msrp: formatPriceValue(pricing?.value),
    freight: formatPriceValue(freightPdi),
    registrationFee: formatPriceValue(ppsaRegistrationFee),
    registeringFee: formatPriceValue(registeringAgentFee),
    downpayment: formatPriceValue(finance?.monthly?.downPayment),
    financeApr: finance?.monthly?.apr,
    weeklyPaymentAmt: formatPriceValue(finance?.monthly?.total),
    months: finance?.monthly?.termOptionsDefault,
    weeklyPayments: numberOfPayments,
    costOfBorrowing: formatPriceValue(costOfBorrowing),
    totalObligation: formatPriceValue(totalAmount + costOfBorrowing),
    frequency: paymentFrequency,
  };
};

export default getFinancingDisclaimerParams;
